// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Buefy from 'buefy';
import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';
import VueMoment from 'vue-moment';

import moment from 'moment';
// import momentDurationFormatSetup from 'moment-duration-format';
import 'moment/locale/fr';
import 'moment/locale/ko';
import 'moment/locale/en-gb';

import '@/filters';

import App from '@/App';
import Axios from '@/custom/axios-plugin';
import config from '@/config';
import i18n from '@/i18n';
import router from '@/router';
import store from '@/store';

import LayoutHeader from '@/components/layout/Header';

Vue.use(Axios);

Vue.use(Buefy, {
  defaultIconPack: 'fas'
});

Vue.use(VueGoogleMaps, {
  load: {
    libraries: 'geometry,places', // necessary for places input
    key: config.googleMaps.apiKey
  }
});

Vue.use(VueMoment, { moment });

Vue.component('layout-header', LayoutHeader);

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  beforeCreate () {
    this.$store.commit('initialiseStore');
    this.$moment.locale('fr');
  },
  router,
  i18n,
  template: '<App/>',
  components: {
    App
  },
  data: {},
  computed: {
    bearer () {
      return this.$store.state.bearer;
    }
  },
  methods: {}
});



// WEBPACK FOOTER //
// ./src/main.js